import Vue from "vue/dist/vue.esm.browser.js";

console.log("vueはここから");
new Vue({
  el: "#app",
  data: {
    labelList: [],
    modalToggle: false,
  },
  created() {},
  beforeMount() {
    this.getInput();
  },
  mounted() {
    // this.getInput();
  },
  methods: {
    getInput() {
      const label = document.getElementsByClassName("pageLandFiter_label");
      console.log("testtest", label);
      for (var i = 0; i < label.length; i++) {
        var checkbox = document.getElementById(label[i].htmlFor);
        if (checkbox.checked) {
          this.labelList.push({
            for: label[i].htmlFor,
            text: label[i].innerHTML,
          });
        }
      }
    },
    submit() {
      setTimeout(() => {
        document.searchform.submit();
      }, 0);
    },
    modalOpen() {
      console.log("modalOpen()");
      this.modalToggle = true;
    },
    modalClose() {
      console.log("modalClose()");
      this.modalToggle = false;
    },
  },
});
